module.exports = __webpack_public_path__ + "img/sandboxtick.695914f1.svg";